module.exports = __webpack_public_path__ + "static/media/logo-코멘토@2x.72ddd4e1.png";